import styled from "styled-components";
import DesignConstants from "../../../constants/DesignConstants";

export const OnboardingStepItemWrapper = styled.button<{ completed: boolean }>`
    display: flex;
    align-items: center;
    padding: ${DesignConstants.SPACES.S};
    background: ${DesignConstants.COLORS.WHITE};
    border-radius: ${DesignConstants.BORDER_RADIUS.XSMALL_CONTAINER};
    transition: all 0.2s ease;
    border: ${DesignConstants.BORDERS.THIN} ${DesignConstants.COLORS.LIGHTEST_GREY};
    width: 100%;
    text-align: start;
    font-family: inherit;

    ${(props) =>
        props.completed ? `opacity: ${DesignConstants.OPACITY.SEVEN}; pointer-events: none;` : "cursor: pointer;"}
`;

export const OnboardingStepCircle = styled.div<{ completed: boolean }>`
    width: ${DesignConstants.SPACES.M};
    height: ${DesignConstants.SPACES.M};
    border-radius: 50%;
    margin-right: ${DesignConstants.SPACES.S};
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: ${DesignConstants.FONT_SIZES.S};
    background: ${DesignConstants.COLORS.WHITE};
    flex-shrink: 0;

    ${(props) =>
        props.completed
            ? `opacity: ${DesignConstants.OPACITY.SEVEN}; background-color: ${DesignConstants.COLORS.P6_SUCCESS_400}`
            : `border: ${DesignConstants.BORDERS.MEDIUM} ${DesignConstants.COLORS.MID_GREY}`}
`;

export const OnboardingStepContent = styled.div`
    flex: 1;
`;

export const OnboardingStepTitle = styled.div`
    font-weight: ${DesignConstants.FONT_WEIGHTS.MEDIUM};
    color: ${DesignConstants.COLORS.DARK_GREY};
    font-size: ${DesignConstants.FONT_SIZES.M};
`;

export const OnboardingStepDescription = styled.div`
    color: ${DesignConstants.COLORS.DARK_GREY};
    font-size: ${DesignConstants.FONT_SIZES.S};
`;
